<template>
  <div class="extra-numerator">
    <section>
      <button @click="decrement()">
        <QIcon name="icon-f-minus-square" />
      </button>
    </section>

    <section prevent-selection>
      <p class="extra-numerator-value">
        <span>{{ displayedValue }}</span>
        <span v-if="symbol">
          {{ symbol }}
        </span>
      </p>
      <p v-if="subtitle" class="extra-numerator-subtitle text-accent">
        <span>
          {{ subtitle }}
        </span>
      </p>
    </section>

    <section>
      <button @click="increment()">
        <QIcon name="icon-f-plus-square" />
      </button>
    </section>
  </div>
</template>

<script>
  import { NumericHelpers } from "@core/helpers";

  export default {
    props: {
      modelValue: { type: Number, default: 0 },
      step: { type: Number, default: 1 },
      min: { type: Number, default: 0 },
      precision: { type: Number, default: 0 },
      symbol: { type: String, default: null },
      subtitle: { type: String, default: null },
    },
    emits: ["update:modelValue"],
    computed: {
      displayedValue() {
        return NumericHelpers.formatToLocaleNumber({
          number: this.modelValue,
          maximumFractionDigits: this.precision || 0,
          minimumFractionDigits: this.precision || 0,
        });
      },
    },
    methods: {
      decrement() {
        this.publish(this.modelValue - this.step > this.min ? this.modelValue - this.step : this.min);
      },
      increment() {
        this.publish(this.modelValue + this.step);
      },
      publish(value) {
        this.$emit("update:modelValue", Math.round(value * 1e2) / 1e2);
      },
    },
  };
</script>

<style lang="scss">
  .extra-numerator {
    display: flex;

    section {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100px;
      font-family: $common-font-family;
      font-size: 22px;
      font-weight: 900;

      p {
        margin: 0;
      }

      .extra-numerator-subtitle {
        font-size: 16px;
      }
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      font-size: 40px;
      color: $accent;
      background: none;
      border: none;
      outline: none;

      &:active {
        background: $accent;
        color: white;
        border-radius: 8px;
      }
    }
  }
</style>
